<template>
  <div class="program-stats container">
    <div class="row">
      <div class="heading col col-4 offset-1">
        <h2 class="h2">
          {{ options.title }}
        </h2>
        <p class="body-1">
          {{ options.subtitle }}
        </p>
        <button
          class="btn-primary btn-lg btn-desktop" data-direct-send :data-event="`${$route.path.replace(/\//g, '')}_stats.click`"
          @click="$emit('scrollToLastSection')"
        >
          {{ buttonText }}
        </button>
      </div>
      <div class="stats col col-4 offset-2">
        <div class="description">
          <span>{{ stats.rounded.courses }}</span>
          courses
        </div>
        <div class="description">
          <span>{{ stats.rounded.videoDuration }}</span>
          hours of video
        </div>
        <div class="description">
          <span>{{ stats.rounded.exercises }}</span>
          exercises
        </div>
        <button
          class="btn-primary btn-lg btn-mobile" data-direct-send :data-event="`${$route.path.replace(/\//g, '')}_stats.click`"
          @click="$emit('scrollToLastSection')"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    options: { type: Object, default: () => {}, required: true },
    buttonText: { type: String, default: '', required: false },
  },
  data() {
    return {
      stats: {
        rounded: {},
      },
    };
  },
  async fetch() {
    const stats = await this.$axios.$get('/stats/courses?reduced=1').catch(() => ({}));
    this.stats = stats;
  },
};
</script>

<style lang="scss" scoped>
.program-stats {
  padding-top: 80px;
  padding-bottom: 80px;

  .row {
    display: flex;

    .body-1 {
      color: var(--main-light-shade-4);
    }

    .btn-primary {
      width: 100%;
      max-width: 350px;
      margin-top: 54px;

      &.btn-mobile {
        display: none;
      }
    }

    .description {
      display: flex;
      align-items: center;
      font-size: 21px;
      font-weight: 500;
      color: var(--main-light-shade-4);
      padding-bottom: 42px;

      span {
        font-size: 80px;
        color: var(--main-light);
        margin-right: 20px;
      }
    }
  }
}

@include bp($bp-laptop) {
  .program-stats {
    .row {
      .description span {
        font-size: 64px;
      }
    }
  }
}

@include bp($bp-mobile) {
  .program-stats {
    .row {
      flex-direction: column;

      .body-1 {
        font-size: 16px;
      }

      .description span {
        font-size: 64px;
      }

      .stats {
        padding-top: var(--spacing-32);
      }

      .btn-primary {
        &.btn-mobile {
          display: block;
          margin: 0 auto;
        }

        &.btn-desktop {
          display: none;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .program-stats {
    padding-top: var(--spacing-60);
    padding-bottom: var(--spacing-60);

    .row {
      .stats .description {
        padding-bottom: 30px;

        span {
          font-size: 50px;
          margin-right: 6px;
        }
      }

      .btn-primary {
        max-width: 100%;
      }
    }
  }
}
</style>
